import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from "../../../../components/ui/common/alert-dialog";

interface RecipeVariantConfirmModalProps {
  viewModal?: boolean;
  closeModal?: () => void;
  cancel?: () => void;
  approve?: () => void;
  title?: string;
  subTitle?: string;
}

const RecipeVariantConfirmModal = ({
  viewModal = false,
  closeModal = () => {},
  cancel = () => {},
  approve = () => {},
  title = "",
  subTitle = ""
}: RecipeVariantConfirmModalProps) => (
  <AlertDialog
    open={viewModal}
    onOpenChange={open => {
      if (!open) {
        closeModal();
      }
    }}
  >
    <AlertDialogContent className="tw-max-w-md">
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{subTitle}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel onClick={cancel}>No</AlertDialogCancel>
        <AlertDialogAction
          onClick={event => {
            event.preventDefault();
            approve();
          }}
          className="tw-bg-destructive tw-text-destructive-foreground hover:tw-bg-destructive/90"
        >
          Yes
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default RecipeVariantConfirmModal;
